import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';

import { Contact } from '../models/contact';

export class ContactApi {
    constructor(protected baseUrl: string) {}

    public cget(poolAccountId: number): Promise<ApiResult<PaginatedResponse<Contact>>> {
        const params = new URLSearchParams({ accountId: poolAccountId.toString(), isLocked: 'false' });

        return safeRequest(
            () => request.get(`${this.baseUrl}/quicksearch/contacts`, { params }),
            response => {
                response.data.items = response.data.items.map(Contact.fromPlainObject);
                return response.data;
            }
        );
    }

    public getContactInfo(
        contactId: number,
        accountId?: number,
        showTopics = false
    ): Promise<ApiResult<Contact | undefined>> {
        const params = { accountId, showTopics };
        return safeRequest(
            () => request.get(`${this.baseUrl}/contacts/${contactId}/contact-info`, { params }),
            response => {
                if (response.status === 204) {
                    return;
                }

                return response.data && Contact.fromPlainObject(response.data);
            }
        );
    }

    public search(
        params: URLSearchParams = new URLSearchParams(),
        abortSignal?: AbortSignal
    ): Promise<ApiResult<PaginatedResponse<Contact>>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/quicksearch/contacts`, { params, signal: abortSignal }),
            response => {
                response.data.items = response.data.items.map(Contact.fromPlainObject);
                return response.data;
            }
        );
    }
}
